import {Outlet} from 'react-router-dom';
import {useAppContext} from "../utils/AppContext";
import Background  from "./home/Background";
import Menu from "./home/Menu";
import {motion} from "motion/react"

const Layout = () => {
    const {
        screenSize
    } = useAppContext();

    return (
       <div className={`home-container${screenSize}`}>
            <Background/>
            <div className={`header-container${screenSize}`}>
                <motion.div
                    initial={{opacity: 0}}
                    whileInView={{opacity: 1}}
                    transition={{duration: 0.7}}
                >
                    <Menu/>
                </motion.div>
            </div>
            <div className={`content-container${screenSize}`}>
                <Outlet/>
            </div>
        </div>
    );

}

export default Layout;

